import React, {Component} from 'react';
import styled from 'styled-components';
import CircleFactory from 'classes/CircleFactory';
import * as helpers from 'helpers';

const Canvas = styled.canvas`
  width: 100vw;
  height: 100vh; 
`;

class Wallpaper extends Component {
  componentDidMount(){
    this.resizeHandler();

    const circleFactory = new CircleFactory();

    this.shapes = helpers.createNInstances(300, () => circleFactory.getRandomMovingCircle(
      this.canvas.width,
      this.canvas.height
    ));

    window.addEventListener('resize', this.resizeHandler);
    this.animationId = requestAnimationFrame(this.draw);

    document.addEventListener('click', (event) => {
      this.shapes = [
        ...this.shapes,
        ...helpers.createNInstances(20, () => circleFactory.getCircle(
          event.clientX,
          event.clientY
        ))
      ]
    })

  }

  resizeHandler = () => {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  };

  draw = () => {
    const ctx = this.canvas.getContext('2d');
    this.clearCanvas();

    this.shapes.forEach(shape => {
      if (Math.random() < .01){
        shape.velocityVector = helpers.getRandomVelocityVector();
      }
      shape.updatePosition();
      shape.draw(ctx)
    });

    requestAnimationFrame(this.draw);
  };

  clearCanvas = () => {
    const ctx = this.canvas.getContext('2d');
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
  };

  componentWillUnmount(){
    window.removeEventListener('resize', this.resizeHandler);
    cancelAnimationFrame(this.animationId);
  }

  render(){
    return (
      <Canvas innerRef={node => { this.canvas = node }}/>
    );
  }
}

export default Wallpaper;



// WEBPACK FOOTER //
// ./src/components/Wallpaper/index.js